import { render, staticRenderFns } from "./errorAlert.vue?vue&type=template&id=71a7ab12&"
import script from "./errorAlert.vue?vue&type=script&lang=js&"
export * from "./errorAlert.vue?vue&type=script&lang=js&"
import style0 from "./errorAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports